import Style from './SinglePage.module.less'
import SubscribeStepContainer from "../SubscribeStep/SubscribeStepContainer";

const SinglePage = () => {
    return (
        <div className={Style.single_box}>
            <SubscribeStepContainer />
        </div>
    )
}
export default SinglePage